import React, { Fragment } from 'react'
import DocPart from '../DocPart'
import infoArr from 'ROOT_SOURCE/config/InfoDcs/Basic'

// 其他信息
const Basic = (props) => {
    return (
        <Fragment>
            <DocPart infos={infoArr} />
        </Fragment>
    )
}

export default Basic;


// WEBPACK FOOTER //
// ./src/containers/InfoDcs/Basic/index.js